import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import moment from 'moment'
import userLogo from "../../../../assets/img/nophoto.png";
import {acceptConnectionRequest, rejectConnectionRequest} from "../../../../actions/profile";

const NotificationItem =  ({userProfile,user_name,user_avtart,title,action,time,user_id,user,acceptConnectionRequest,rejectConnectionRequest,notificationId}) => {
    return (
        <div className="dropdown-item">

            <div className="d-flex">
                <div className="notification-user-avatar">
                    <img src={userProfile} alt="logo" className="rounded-circle "/>
                </div>

                    <div className="w-100 ml-2">
                    <p className="p-0 m-0">{user_name}</p>
                        <p className="p-0 m-0">{title}</p>
                        <div className={`fotter ${action !== 'REQUEST' && 'float-right'}`}>
                            {action === 'REQUEST' &&
                                <Fragment>
                                    <div className="d-flex align-items-center">
                                        <button className="btn notification-btn-accept  notification-btn mr-2" onClick={() => acceptConnectionRequest(user._id,user_id,notificationId)}> Accept</button>
                                        <button className="btn notification-btn-decline border notification-btn ml-2" onClick={() =>  rejectConnectionRequest(user._id,user_id,notificationId)}>Decline</button>
                                    </div>

                                </Fragment>}
                            <div>
                                <p className="h6 p-0 m-0 d-flex align-items-center  "><i className="fal fa-clock custom-text-color1  mr-1"/>  <small> <strong>{moment(time).format('MMMM Do YYYY')} </strong> </small></p>

                            </div>
                        </div>
                    </div>


            </div>

            <hr/>
        </div>

    );
};


const mapStateToProps = state => ({
    user: state.auth.user,
});

export default connect(mapStateToProps, {acceptConnectionRequest,rejectConnectionRequest})(NotificationItem)
